import { defineMessages } from 'react-intl-next';

export default defineMessages({
	promptPlaceholder: {
		id: 'dev-agents.boysenberry.dashboard.prompt.placeholder',
		defaultMessage: 'Ask AI to code something for you',
		description: 'Placeholder text shown in the AI prompt input field.',
	},
});
